import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import Card9 from "../Images/Profiles/Livingstone.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function LivingstoneKilwa() {
  return (
    <div className="ne-page">
      <SEO
        title="Mr. Livingstone Kilwa - Laboratory Technician"
        description="Mr. Livingstone Kilwa is a Laboratory Technician at CIRCODU with a Bachelor's Degree in Development Studies."
        keywords="Livingstone Kilwa, Laboratory Technician, CIRCODU, Bachelor's Degree, Development Studies"
        url="/livingstone-kilwa"
        image={Card9}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Mr. Livingstone Kilwa</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/the-staff-team">
              The Staff Team
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Mr. Livingstone Kilwa
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card9} alt="Mr. Livingstone Kilwa" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Mr. Livingstone Kilwa</h1>
                <p className="profile-card__role">Laboratory Technician</p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Kilwa Livingstone holds a Bachelor's Degree in Development
                  Studies from Makerere University in Uganda. His educational
                  foundation is fortified by an array of valuable certificates
                  that underscore his commitment to skill acquisition and
                  practical expertise.
                </p>
                <p>
                  Livingstone's qualifications include a Certificate in
                  Community Business Development from the Uganda National
                  Entrepreneurship Development Institute (UNEDI), affirming his
                  proficiency in fostering community-driven business
                  initiatives. He has also acquired a Certificate in Laboratory
                  Management Systems, a testament to his adeptness in overseeing
                  the intricate aspects of laboratory operations.
                </p>
                <p>
                  With a seasoned career spanning over three years, Livingstone
                  has cultivated a robust expertise in Emissions and Air Quality
                  monitoring. His competence is fortified by certificates in key
                  methodologies, including the Water Boiling Test Version 4.2.3,
                  which demonstrates his prowess in assessing emissions and
                  efficiency within controlled laboratory settings. He is also
                  certified in the Controlled Cooking Test (C.C.T), further
                  attesting to his comprehensive grasp of testing methodologies.
                  Moreover, Livingstone holds a Certificate in Emissions Testing
                  Methods and Protocols, underpinning his meticulous approach to
                  data collection and analysis. His proficiency extends to the
                  testing of stoves using the Uganda Standard US 761, showcasing
                  his commitment to adhering to industry benchmarks.
                </p>
                <p>
                  In addition to his technical achievements, Livingstone has
                  made impactful contributions in various roles. He previously
                  served as a Community Business Development Advisor at The
                  Uganda National Entrepreneurship Development Institute, where
                  his insights were pivotal in fostering sustainable
                  community-based businesses. His engagement further expanded as
                  he took on the role of a Community Liaison Officer with Bugaya
                  Area Cooperative Marketing Enterprise, demonstrating his
                  commitment to effective community engagement and
                  collaboration.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://www.linkedin.com/in/kilwa-livingstone-659436180/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/Stone8924"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/kilwa.livingstone/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256706901771"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:kilwa.livingstone@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LivingstoneKilwa;
